import React, { Component } from "react";
import { connect } from "react-redux";
import TrackedKeywordsChartModal from "../../components/TrackedKeywords/TrackedKeywordsChartModal";
import { fetchKeywordOverviews } from "../../store/tracked_keywords/operations";
import { isFetchingKeywordOverview, getKeywordOverviews } from "../../store/tracked_keywords/selectors";

class TrendChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };
  }

  toggleModal = () => {
    this.setState(prevState => ({
      visible: !prevState.visible
    }));
  };

  handleOpenModal = _ => {
    this.props.fetchKeywordOverviews(this.props.domain, this.props.keyword, this.props.seoDb);
    this.toggleModal();
  };

  render() {
    return (
      <TrackedKeywordsChartModal
        domain={this.props.domain}
        keyword={this.props.keyword}
        seoDb={this.props.seoDb}
        isLoading={this.props.isLoading}
        keywordOverviews={this.props.keywordOverviews}
        modalTitle={this.props.modalTitle}
        openLabel={this.props.openLabel}
        fetchKeywordOverviews={this.props.fetchKeywordOverviews}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { domain, keyword, seoDb } = ownProps;
  const keywordHashKey = `${domain}:${keyword}:${seoDb}`;
  return {
    isLoading: isFetchingKeywordOverview(state, keywordHashKey),
    keywordOverviews: getKeywordOverviews(state, keywordHashKey)
  };
};

export default connect(
  mapStateToProps,
  { fetchKeywordOverviews }
)(TrendChart);
